import MainLayout from "../components/SharedComponents/MainLayout";
import HeroSection from "../components/ContactPageComponents/HeroSection";
import FormSection from "../components/ContactPageComponents/FormSection";
import MapSection from "../components/ContactPageComponents/MapSection";

export default function ContactUsPage() {
    return (
      <div>
        <MainLayout>
          <HeroSection />
          <FormSection />
          <MapSection />
        </MainLayout>
      </div>
    );
  }
  
